import { AccessTokenTypesConstants } from "."

export default {
  JWT: 0,
}

export const AccessTokenTypeDisplayName = (type) => {
  switch (type) {
    case AccessTokenTypesConstants.JWT:
      return "JWT"
    default:
      return null
  }
}